import { render, staticRenderFns } from "./ServiceRate.vue?vue&type=template&id=59dd9bf5&scoped=true&"
import script from "./ServiceRate.vue?vue&type=script&lang=js&"
export * from "./ServiceRate.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRate.vue?vue&type=style&index=0&id=59dd9bf5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd9bf5",
  null
  
)

export default component.exports